import { GlobalControlApi } from "features/brm";

export const useMergeBaselineModalApi = () => {
  const { mutate: mergeBaseline, error: mergeBaselineError } = GlobalControlApi.useMergeStandardBaseline();

  return { mergeBaseline, mergeBaselineError };
};
